import { PickType } from '@nestjs/swagger';

import { JobPhasePaidDto } from './job-phase-paid.dto';
import { JobPhasePaidCreatableInterface } from '../interfaces/job-phase-paid-creatable.interface';

export class JobPhasePaidCreateDto
  extends PickType(JobPhasePaidDto, ['paid', 'jobPhaseId'])
  implements JobPhasePaidCreatableInterface {}
